import DocViewer, {DocViewerRenderers} from '@cyntler/react-doc-viewer'
import {useContext} from 'react'
import {Col, Container, Row} from 'react-bootstrap'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import {PdfLoadingSpinner} from '../../../../generales_component/PdfLoadingSpinner'
import {DocumentLoadDetailContext} from '../DocumentLoadDetailContext'

const ShowFile2ModalForm = () => {
  const {documentoArray, loadingNewPdf} = useContext(DocumentLoadDetailContext)

  return (
    <>
      <Container className='mt-5'>
        <Row>
          <Col sm={12} style={{position: 'relative'}}>
            {loadingNewPdf ? (
              <div>
                <PdfLoadingSpinner />
              </div>
            ) : (
              <DocViewer
                documents={documentoArray as any}
                pluginRenderers={DocViewerRenderers}
                style={{height: 850}}
              />
            )}
          </Col>
        </Row>
      </Container>
    </>
  )
}

export {ShowFile2ModalForm}
